<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
    <path
      fill="#2196f3"
      d="M47,35H16.017c-0.551,0-1-0.445-1-1v-9H45.32c1.555,0,2.68,1.133,2.68,2.695V34 C48,34.555,47.555,35,47,35z"
    />
    <path fill="#424242" d="M5.017,40h-5V16h5v15H48v9h-5v-4H5.017V40z" />
    <path fill="#e53935" d="M23 6H25V16H23z" />
    <path fill="#e53935" d="M23 6H25V16H23z" transform="rotate(90 24 11)" />
    <path fill="#90caf9" d="M15,29H5v-7h7c1.657,0,3,1.343,3,3V29z" />
    <path fill="#eee" d="M5 29H15V31H5z" />
    <title v-if="title !== ''">{{ title }}</title>
  </svg>
</template>

<script>
export default {
  name: "ScriptIcon",
  props: {
    title: {
      type: String,
      default: "",
    },
  },
};
</script>
